import React, { useState } from "react";

const ResetPassword = ({ onSigninSuccess, onSignupClick }) => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [emailSent, setEmailSent] = useState(false);

  const validateForm = () => {
    let valid = true;
    let emailError = "";

    if (!email) {
      emailError = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailError = "Please enter a valid email address.";
      valid = false;
    }

    setErrors({ email: emailError });
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setEmailSent(true);
    }
  };

  const handleBackToLogin = () => {
    if (onSigninSuccess) {
      onSigninSuccess();
    }
  };

  return (
    <div className="h-full w-full max-w-sm mx-auto">
      <div className="bg-white rounded-3xl h-full p-9 pt-[10rem]">
        {!emailSent ? (
          <>
            <h1 className="font-young-serif text-[30px] font-normal text-[#1E0A1E] leading-8 text-center pb-11">
              Reset password
            </h1>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="w-full border border-gray-300 text-[#6B7280] font-space-grotesk text-[16px] rounded-full px-5 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                {errors.email && (
                  <p className="text-red-500 font-space-grotesk text-sm mt-1">
                    {errors.email}
                  </p>
                )}
              </div>
              <p className="text-[#929292] text-[12px] font-space-grotesk mt-1">
                We'll email you a link to reset your password
              </p>
              <button
                type="submit"
                className="bg-[#B08CFF] font-space-grotesk w-full text-[#1E0A1E] text-[18px] font-bold py-2 rounded-full hover:bg-purple-600 transition duration-200"
              >
                Send
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <p className="font-space-grotesk font-normal text-[16px] text-[#1E0A1E] leading-[20px] mb-8">
              If your account is associated with this email address you will receive an email to reset your password. If you don't, please try another email address.
            </p>
            <button
              onClick={handleBackToLogin}
              className="bg-[#B08CFF] font-space-grotesk w-full text-[#1E0A1E] text-[18px] font-bold py-2 rounded-full hover:bg-purple-600 transition duration-200"
            >
              Back to login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;